var __jsx = React.createElement;
import { FrownOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuText from "../DixuText/DixuText";
import { withTranslation } from "../../i18n";
import React from 'react';
class DixuErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: undefined
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error?.message
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }
  render() {
    const {
      t,
      errorText,
      className,
      children
    } = this.props;
    const {
      hasError,
      errorMessage
    } = this.state;
    if (hasError) {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('dixu-error-boundary', className)
      }, /*#__PURE__*/React.createElement(DixuRow, {
        gutter: [0, 16]
      }, /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, /*#__PURE__*/React.createElement(DixuText, {
        font: "2",
        color: "2-8",
        align: "center",
        weight: "bold",
        block: true
      }, errorText || /*#__PURE__*/React.createElement(DixuRow, {
        gutter: [0, 4]
      }, /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, /*#__PURE__*/React.createElement(DixuText, {
        font: "5"
      }, /*#__PURE__*/React.createElement(FrownOutlined, null))), /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, t('common:SomethingWentWrong'))))), errorMessage && /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, /*#__PURE__*/React.createElement(DixuRow, {
        justify: "center"
      }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
        font: "2",
        color: "2-8",
        weight: "bold",
        block: true,
        whiteSpace: "pre-line",
        className: "dixu-error-boundary__message border-radius-md"
      }, errorMessage))))));
    }
    return children;
  }
}
DixuErrorBoundary.defaultProps = {
  errorText: undefined
};
export default withTranslation(['common'])(DixuErrorBoundary);